export const apiConstants = {
  users: "/api/user",
  roles: "/api/role"
};
